module.exports = __webpack_public_path__ + "front-end-web-app.3pFRAyoo.svg";